/** The Spanish catalogue for the door — the wording only. Why each entry exists is argued in `en/door.ts`. */
export default {
  sub: 'A Arena se entra con el teléfono. No hay otra manera de abrirla.',
  mode: 'LA PUERTA — inicia sesión con el teléfono',
  scan: 'Escanea esto con la aplicación y comprueba que el código de abajo coincida.',
  code: 'código',
  expires_in: 'vence en',
  ttl: '{n} s',
  signed_in_as: 'sesión iniciada como',
  group: 'grupo',
  start: 'Comenzar',
  proceed: 'Continuar',
  get_app: 'Descarga la aplicación A-Airsoft',
  sign_out: 'Cerrar sesión',
  ready: 'LISTO',
  stopped: 'DETENIDO',

  err_offline: 'La puerta no puede alcanzar el servicio. Comprueba la conexión y vuelve a intentarlo.',
  err_off: 'La puerta QR está apagada en este servicio.',
  err_ticket: 'La puerta no pudo emitir un código (HTTP {code}).',
  err_denied: 'El teléfono rechazó este navegador.',
  err_lapsed: 'Nadie aprobó este navegador. Vuelve a empezar con el teléfono a mano.',
  err_claim: 'La puerta rechazó la aprobación ({why}).',
  err_backend: 'El backend rechazó este navegador ({code}).',
  err_gate: 'El servicio rechazó esta sesión (HTTP {code}).',
  err_gate_down: 'Este servicio no responde. Vuelve a intentarlo en un momento.',
  err_busy: 'El servicio no pudo comprobar esta sesión. Vuelve a intentarlo en {s} s.',
  err_too_many: 'Demasiados intentos desde esta dirección. Vuelve a intentarlo en {s} s.',
  err_in_app: 'Arena no se abrió con la sesión de este teléfono, y dentro de la aplicación no hay ningún código que escanear.',
  err_unknown: 'No se pudo abrir la puerta.',
};
